import { Pagination, Select, Spin, Table, Typography } from 'antd';

import { PF } from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import type {
  InventoryProduct,
  ProductsType,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

const TABLE = `${PF}_table`;
const { Text } = Typography;

export const Products: ProductsType = ({
  isLoading,
  isFetching,
  data,
  columns,
  pagination: { itemsPerPage, pageN, total, from, to },
  onPaginate,
  onPageSizeChange,
}) => {
  if (isLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_scroll-wrapper`}>
        <Table<InventoryProduct>
          columns={columns}
          dataSource={data}
          rowKey={({ id }) => id}
          pagination={false}
          size="middle"
          loading={isFetching}
          scroll={{ x: 'max-content' }}
        />
      </div>
      {data?.length > 0 && (
        <div className={`${TABLE}_pagination`}>
          <div className={`${TABLE}_pagination_left`}>
            <Pagination
              current={pageN}
              total={total}
              pageSize={itemsPerPage}
              showSizeChanger={false}
              onChange={onPaginate}
            />
            <Text>
              Показаны результаты с {from} по {to} из {total}
            </Text>
          </div>
          <div className={`${TABLE}_pagination_right`}>
            <Select<number>
              value={itemsPerPage}
              onChange={onPageSizeChange}
              popupMatchSelectWidth={false}
              options={[10, 20, 50, 100].map((n) => ({ label: n, value: n }))}
              className="select"
            />
            <Text>результатов на странице</Text>
          </div>
        </div>
      )}
    </div>
  );
};
